<template>
  <button
    @click="onHelpNavClick"
    :disabled="!doc360Visible"
    class="btn h-[42px] p-3 disabled:opacity-50 text-blue-600 font-semibold drop-shadow-sm border-gray-400 focus:border-blue-600 hover:border-blue-600 hover:bg-blue-600 hover:text-gray-100"
  >
    <LifebuoyIcon
      class="h-5 w-5"
      aria-hidden="true"
      alt="help"
    />
  </button>
</template>

<style>
/* Hide the default widget button */
#document360-widget-iframe {
  display: none !important;
}
</style>

<script setup>
import { onMounted, ref } from 'vue'
import { LifebuoyIcon } from '@heroicons-2/vue/24/outline'

const doc360Visible = ref(window?.mw)

onMounted(() => {
  if (window?.mw) {
    return
  }
  // Doc 360 snippet.
  ;(function (w, d, s, o, f, js, fjs) {
    w['JS-Widget'] = o
    w[o] =
      w[o] ||
      function () {
        ;(w[o].q = w[o].q || []).push(arguments)
      }
    ;(js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0])
    js.id = o
    js.src = f
    js.async = 1
    fjs.parentNode.insertBefore(js, fjs)
  })(window, document, 'script', 'mw', 'https://cdn.document360.io/static/js/widget.js')

  // We need to toggle the availability of the help button using the callbacks.
  window.mw('init', {
    apiKey:
      'lqxgwZAJYGvUHX+Q4UF8zqaKOkNhiP/VunLBo7RR7sd8bG6UwASqBblRKy61c2HSLnNEM16cloc3sHlrG7kqZJMW06n8ccgGzsdwe4TkGEBEipnyxbsCvDlT3ZRzX8Y7VsH02YFMGqBA45mmxheYMg==',
    callback: function () {
      doc360Visible.value = true
    },
    show_callback: function () {
      doc360Visible.value = true
    },
    hide_callback: function () {
      doc360Visible.value = false
    }
  })
})

// We're hiding the default doc360 button and manually triggering it with this button.
const onHelpNavClick = () => {
  document.getElementById('document360-widget-iframe').contentDocument.getElementById('doc360-button').click()
}
</script>
